@if (call$ | async; as result) {
  @if (result.isPending) {
    <app-spinner></app-spinner>
  } @else if (result.isError) {
    @if (result.error.error.message; as accessInfo) {
      @if (accessInfo && !accessInfo.hasAccess && accessInfo.sameOrganization) {
        <div class="access-denied-container">
          <h2 translate="CALLS.ACCESS_DENIED_TITLE"></h2>
          <p translate="CALLS.ACCESS_DENIED_MESSAGE" [translateParams]="{ callName: accessInfo.callName }"></p>

          @if (accessInfo.users.length > 0) {
            <div class="user-list-section">
              <h3 translate="CALLS.REQUEST_ACCESS_FROM"></h3>
              <ul class="user-list">
                @for (user of accessInfo.users; track user.id) {
                  <li>
                    <span class="user-name">{{ user.firstName }} {{ user.lastName }}</span>
                    <a href="mailto:{{ user.email }}" class="user-email">{{ user.email }}</a>
                  </li>
                }
              </ul>
              <p class="request-hint" translate="CALLS.REQUEST_ACCESS_HINT"></p>
            </div>
          }
        </div>
      } @else {
        <h2 class="failed-to-load" translate="COMMON.FAILED_TO_LOAD"></h2>
      }
    }
  } @else {
    @if (result.data; as call) {
      <div class="page-container">
        <app-toolbar [title]="call.name" [backButtonLink]="constructBackButtonLink(call)">
          <div class="actions">
            @if (call.transcript.length > 0) {
              <button mat-icon-button class="export" (click)="exportCall(call)" [matTooltip]="'COMMON.EXPORT' | translate">
                <mat-icon>download</mat-icon>
              </button>
            }

            @if (currentUser$ | async; as user) {
              @if (user.organization.isSharingEnabled) {
                <button mat-icon-button class="share" (click)="share(call)" [matTooltip]="'COMMON.SHARING' | translate">
                  <mat-icon>share</mat-icon>
                </button>
              }
              @if (user.role === 'SUPER') {
                <button mat-icon-button class="timeline" (click)="showTimeline(call)" [matTooltip]="'CALLS.TIMELINE.BUTTON_TOOLTIP' | translate">
                  <mat-icon fontSet="material-symbols-outlined">schedule</mat-icon>
                </button>
              }
            }
            @if (!call.isUpcoming && !call.isOngoing) {
              <button mat-icon-button class="info" (click)="toggleInfoPanel()" [matTooltip]="'CALLS.CALL_INFO.TITLE' | translate">
                <mat-icon>info_outline</mat-icon>
              </button>
            }
          </div>
          <div class="details">
            {{ call.date | date: 'd MMM y' }} •
            {{ call.date | date: 'HH:mm' }}
            @if (call.duration !== null) {
              • {{ call.duration | duration }}
            }
            @if (!call.isUpcoming && !call.isOngoing) {
              <span
                class="expiry-badge"
                [class.urgent]="isExpiryUrgent(call.deletionDateDueToRetention)"
                [matTooltip]="getExpiryTooltip(call.deletionDateDueToRetention)"
              >
                {{ getExpiryText(call.deletionDateDueToRetention) }}
              </span>
              @if (templateItems$ | async; as templateItems) {
                <app-meeting-health-indicator [userActionsItems]="getMeetingHealthItems(call, templateItems)"></app-meeting-health-indicator>
              }
            }
            @if (call.callSetIndex !== null && call.callSetSize !== null && call.callSetSize > 1) {
              <span class="part-badge" [matTooltip]="'CALLS.PART_BADGE_TOOLTIP' | translate: { index: call.callSetIndex + 1, total: call.callSetSize }">
                {{ 'CALLS.PART_BADGE_TEXT' | translate: { index: call.callSetIndex + 1, total: call.callSetSize } }}
              </span>
            }
            @if (call.processingStatus) {
              <mat-chip>{{ 'CALLS.PROCESSING_STATUSES.' + call.processingStatus | translate }}</mat-chip>
            }
          </div>
        </app-toolbar>
        <div class="page">
          <div class="wrapper">
            @if (call.isUpcoming || call.isOngoing) {
              <app-call-info [call]="call" [canEdit]="canUserEdit(call)"></app-call-info>
            } @else {
              <mat-drawer-container class="drawer-container">
                <mat-drawer class="sidenav" mode="over" position="end" [opened]="isInfoPanelOpen$ | async">
                  <app-call-info [call]="call" [canEdit]="canUserEdit(call)"></app-call-info>
                  <div class="close-icon">
                    <button mat-icon-button (click)="toggleInfoPanel()">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                </mat-drawer>
                <div class="main-content">
                  <as-split [direction]="useVerticalMode ? 'vertical' : 'horizontal'" [gutterSize]="0">
                    <as-split-area [size]="editorSize" [lockSize]="true">
                      <div class="left-side-container">
                        <div class="outputs">
                          <app-call-outputs-container
                            [call]="call"
                            [canUserEdit]="canUserEdit(call)"
                            [canUserComment]="canUserComment(call)"
                            (openAgendaUpload)="callResourcesContainer?.handleAgendaTabClick()"
                            (openDocument)="callResourcesContainer?.handleOpenDocumentEvent($event)"
                            (openMeeting)="callResourcesContainer?.switchToMeetingTab()"
                          ></app-call-outputs-container>
                        </div>
                      </div>
                    </as-split-area>
                    <as-split-area [size]="100 - editorSize" [lockSize]="true">
                      <div class="right-side-container">
                        <app-call-resources-container
                          [canEdit]="canUserEdit(call)"
                          [userHasEditorAccess]="userHasEditorAccess(call)"
                          [call]="call"
                        ></app-call-resources-container>
                      </div>
                    </as-split-area>
                  </as-split>
                </div>
              </mat-drawer-container>
            }
          </div>
        </div>
      </div>
    }
  }
}
